import { configuration } from '../../../app/common-reducers.js';
import { fetchResultContent, nextPreview, previousPreview, updateContentURL, } from '../../../features/result-preview/result-preview-actions.js';
import { resultPreviewReducer as resultPreview } from '../../../features/result-preview/result-preview-slice.js';
import { loadReducerError } from '../../../utils/errors.js';
import { buildController, } from '../../controller/headless-controller.js';
/**
 * Creates a `Quickview` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `Quickview` properties.
 * @param fetchResultContentCallback - The callback to be triggered after executing fetchResultContent.
 * @returns A `Quickview` controller instance.
 */
export function buildCoreQuickview(engine, props, buildResultPreviewRequest, path, fetchResultContentCallback) {
    if (!loadQuickviewReducers(engine)) {
        throw loadReducerError;
    }
    const { dispatch } = engine;
    const getState = () => engine.state;
    const controller = buildController(engine);
    const { result, maximumPreviewSize } = props.options;
    const getUniqueIdFromPosition = () => {
        const { resultsWithPreview, position } = getState().resultPreview;
        return resultsWithPreview[position];
    };
    const onFetchContent = (uniqueId) => {
        dispatch(updateContentURL({
            uniqueId,
            requestedOutputSize: maximumPreviewSize,
            buildResultPreviewRequest,
            path,
        }));
        if (!props.options.onlyContentURL) {
            dispatch(fetchResultContent({
                uniqueId,
                requestedOutputSize: maximumPreviewSize,
            }));
        }
        if (fetchResultContentCallback) {
            fetchResultContentCallback();
        }
    };
    return {
        ...controller,
        fetchResultContent() {
            onFetchContent(result.uniqueId);
        },
        next() {
            dispatch(nextPreview());
            onFetchContent(getUniqueIdFromPosition());
        },
        previous() {
            dispatch(previousPreview());
            onFetchContent(getUniqueIdFromPosition());
        },
        get state() {
            const state = getState();
            const resultHasPreview = result.hasHtmlVersion;
            const preview = state.resultPreview;
            const content = result.uniqueId === preview.uniqueId ? preview.content : '';
            const isLoading = preview.isLoading;
            const contentURL = preview.contentURL;
            const currentResultUniqueId = getUniqueIdFromPosition();
            return {
                content,
                resultHasPreview,
                isLoading,
                contentURL,
                currentResultUniqueId,
            };
        },
    };
}
function loadQuickviewReducers(engine) {
    engine.addReducers({ configuration, resultPreview });
    return true;
}
